<template>
    <div class="documents-style">
        <b-alert show dismissible fade v-if='successmsg'>{{ successmsg }}</b-alert>
        <!-- barsha -->
        <div class="row no-gutters py-2 mb-3">
            <div class="col-sm-5 company-form-box-title">
                <div class="custom-search ess-leave-list">
                    <b-input-group>
                        <b-input-group-prepend is-text>
                            <b-icon icon="search"></b-icon>
                        </b-input-group-prepend>
                        <b-form-input type="search" placeholder="Search..." v-model="search"
                            @input="resetPagination()"></b-form-input>
                    </b-input-group>
                </div>
            </div>
            <div class="col-sm-7 cursor-pointer text-right company-form-box-title" v-if="flg == 1">
                <b-button @click="addNew()"><b-icon icon="plus"></b-icon> Add New</b-button>
            </div>
        </div>
        <!-- barsha -->

        <b-overlay :show="showoverlay_list" rounded="sm">
            <table class="table document-custom-sorting-table-btn">
                <thead>
                    <tr class="table-head">
                        <template v-for="column in columns">
                            <th v-if="column.name != 'created_at'" @click="sortBy(column.name)"
                                :class="sortKey === column.name ? (sortOrders[column.name] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"
                                style="width: 40%; cursor:pointer;"><label
                                    class="custom-label-doc">{{ column.label }}</label></th>
                        </template>
                        <th class="document-list-file-th">File</th>
                        <th v-if="flg == 1">Action</th>
                    </tr>
                </thead>

                <tbody>
                    <tr class="hover-bg table-row border-bottom mx-2" v-for="doc in paginatedData" :key="doc.id">
                        <td>{{ doc.name }}</td>
                        <td>{{ types[doc.type].text }}</td>
                        <td>
                            <div class="col-sm-12 align-self-center mt-2 text-center" v-if="doc.file_name">
                                <b-link
                                    @click="downloadFileContent('data/employee/' + doc.company_id + '/documents/' + doc.file_name)">
                                    <!-- barsha -->
                                    <img :src="$api_url + '/images/download_image.png'" class="" />
                                    <!-- <b-icon icon="download" scale="2"></b-icon> -->
                                    <!-- barsha -->
                                </b-link>
                            </div>
                        </td>

                        <td class="float-right" v-if="flg == 1">
                            <div class="position-relative">
                                <b-button-toolbar>
                                    <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle"
                                        style="font-size: 16px;" href="#" role="button" data-toggle="dropdown"
                                        aria-haspopup="true" aria-expanded="false"><b-icon
                                            icon="three-dots-vertical"></b-icon></a>
                                    <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                                        <b-button-group>
                                            <b-button variant="outline-secondary" @click="editDocument(doc.id)">
                                                <b-icon icon="pencil"></b-icon> Edit
                                            </b-button>
                                            <b-button variant="outline-secondary" @click="deleteDocument(doc.id)">
                                                <b-icon icon="trash"></b-icon> Delete
                                            </b-button>
                                        </b-button-group>
                                    </div>
                                </b-button-toolbar>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>

            <div class="">
                <div class="clearfix mt-2 mb-4">
                    <ul class="pagination b-pagination float-left mb-0 mt-1">
                        <li class="page-item disabled m-2">View</li>
                        <li class="page-item disabled"><b-form-select v-model="temp_length" :options="length_options"
                                @change="setFirstPage()"></b-form-select></li>
                        <li class="page-item disabled m-2">per page. Total {{ documents.length }} records found.</li>
                    </ul>
                    <b-pagination-nav class="float-right mt-1" v-model="pagination.currentPage"
                        :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#"
                        first-number last-number></b-pagination-nav>

                </div>
            </div>

        </b-overlay>



        <b-modal id="bv-modal-employment-documents" size="lg" :modal-class="'w-600'" hide-footer no-close-on-backdrop
            title="Employment Documents" v-if="flg == 1">
            <ul>
                <li clase="text-uppercase" v-for='data in errormsg'>{{ data[0] }}</li>
            </ul>
            <b-overlay :show="showoverlay" rounded="sm">
                <b-form @submit.stop.prevent="onSubmit">
                    <input type="hidden" v-model="fdata.id" name="id">

                    <b-form-group id="name-group" label="Name" class="" label-for="name">
                        <b-form-input id="name" name="name" v-model="fdata.name"
                            v-validate="{ required: true, min: 3, regex: /^[-\w\s]+$/ }" :state="validateState('name')"
                            aria-describedby="name-feedback" data-vv-as="Name"></b-form-input>
                        <b-form-invalid-feedback id="name-feedback">{{ veeErrors.first('name')
                            }}</b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group id="type-group" class="" label="Type" label-for="type">
                        <b-form-select id="type" name="type" v-model="fdata.type" v-validate="{ required: true }"
                            @change="checkType()" :options="types_options" :state="validateState('type')"
                            aria-describedby="type-feedback" data-vv-as="Type"></b-form-select>
                        <b-form-invalid-feedback id="type-feedback">{{ veeErrors.first('type')
                            }}</b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group id="upload_file-group" label="File" label-for="upload_file">
                        <b-form-file id="upload_file" v-model="upload_file"
                            @change="checkFileType($event, 'upload_file', ['.jpg', '.png', '.gif', '.pdf', '.doc', '.docx'])"
                            ref="upload_file" accept=".jpg, .png, .gif, .pdf , .doc , .docx"
                            placeholder="Choose a file or drop it here..."
                            drop-placeholder="Drop file here..."></b-form-file>

                    </b-form-group>

                    <b-form-group label=" " class="text-center">
                        <b-button class="ml-2 btn-primary custom-wizard-btn" @click="resetForm()"
                            v-if="fdata.id < 1">Reset</b-button>
                        <b-button class="btn-primary" type="submit" variant="primary">Submit</b-button>
                    </b-form-group>
                </b-form>
            </b-overlay>
        </b-modal>



    </div>
</template>


<script>
export default {

    mounted() {
    },
    props: ['flg'],
    data() {

        let sortOrders = {};
        let columns = [
            { label: 'Name', name: 'name' },
            { label: 'Type', name: 'type' },
            { label: '', name: 'created_at' },

        ];
        columns.forEach((column) => { sortOrders[column.name] = -1; });

        return {

            existing_types: [],
            documents: [],
            successmsg: null,
            errormsg: [],
            showoverlay: false,
            fdata: { id: null, name: null, type: null },
            upload_file: null,
            disable_me: false,
            types: [
                { value: null, text: "Select..." },
                { value: "1", text: "Employment Contract" },
                { value: "2", text: "HR Certificate" },
                { value: "3", text: "Salary Certificate" },
                { value: "4", text: "Tax Documents" },

            ],
            types_options: [
                { value: null, text: "Select..." },
                { value: "1", text: "Employment Contract" },
                { value: "2", text: "HR Certificate" },
                { value: "3", text: "Salary Certificate" },
                { value: "4", text: "Tax Documents" },
                ,
            ],

            blankmsg: 'Fetching data..',
            search: '',

            columns: columns,
            sortKey: 'name',
            sortOrders: sortOrders,
            length: 20,
            // pagination : {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', pages:1},
            temp_length: 20,
            showoverlay_list: false,
            pagination: { currentPage: 1, pages: 1 },

            length_options: [{ value: 20, text: "20" },
            { value: 50, text: "50" },
            { value: 100, text: "100" },
            { value: 200, text: "200" },
            { value: 500, text: "500" },],


        }

        /**
         * 1-Employment Contract, 2-Contract Change Letter,3-Salary Certificate,4-Experience Certificate, 5-Release Letter
        */
    },
    methods: {
        checkType: function () {
            /*if((this.fdata.type < 3) && (this.fdata.id == null))
            {
                this.fdata.name = this.types[this.fdata.type].text;
                this.disable_me = true;
            }
            else
            {
                if(this.fdata.id == null)
                {
                    this.disable_me = false;
                    this.fdata.name = '';
                }
            }   */
        },
        getDocumentList: function () {
            if (!this.checkNet()) return false;
            let currentObj = this;
            axios.get(this.$api_url + '/front/employment-document', {
                params: {

                }
            }).then(function (response) {
                this.documents = response.data;

                if (this.documents.length == 0)
                    this.blankmsg = "No doucments found";

                else {
                    /*this.existing_types = this.documents.map(item => item.type);

                    if(this.existing_types.includes(2))this.$delete(this.types_options , 2);
                    if(this.existing_types.includes(1))this.$delete(this.types_options , 1);*/


                    this.sortOrders['created_at'] = 1;
                    this.sortBy('created_at');
                }



            }.bind(this)).catch(function (error) { currentObj.serverError(error); });
        },
        editDocument: function (x) {
            if (!this.checkNet()) return false;
            let currentObj = this;


            axios.get(this.$api_url + '/front/employment-document/details', {
                params: {
                    id: x
                }
            }).then(function (response) {
                this.fdata = response.data;

                if (this.fdata.type < 3) this.disable_me = true;
                else this.disable_me = false;

                this.$validator.reset();

                this.$bvModal.show('bv-modal-employment-documents');

            }.bind(this)).catch(function (error) { currentObj.hr_showoverlay = false; currentObj.serverError(error); });

        },
        deleteDocument(id) {

            //return false; // disabled by developer
            if (!this.checkNet()) return false;
            let currentObj = this;

            this.$bvModal.msgBoxConfirm('Please confirm that you want to delete this work location.', {
                title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false, centered: true
            })
                .then(value => {
                    if (value) {

                        this.hr_showoverlay = true;
                        let formData = new FormData();
                        formData.append('id', id);

                        axios.post(this.$api_url + '/front/employment-document/delete', formData).then(function (response) {

                            if (response.data.status == true) {
                                this.$bvToast.toast(response.data.meg, {
                                    title: `Success`,
                                    variant: 'success',
                                    solid: true
                                });

                                this.getDocumentList();

                            }
                            else {
                                this.$bvToast.toast(response.data.meg, {
                                    title: `Warning`,
                                    variant: 'warning',
                                    solid: true
                                });
                            }

                            this.resetPagination();
                            this.hr_showoverlay = false;

                        }.bind(this))
                            .catch(function (error) {
                                currentObj.hr_showoverlay = false;
                                currentObj.serverError(error);
                            });
                    }
                })
                ;
        },
        validateState(ref) {
            if (
                this.veeFields[ref] &&
                (this.veeFields[ref].dirty || this.veeFields[ref].validated)
            ) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        resetForm() {
            this.fdata = { id: null, name: '', type: null };
            this.upload_file = null;
            this.disable_me = false;

            this.$nextTick(() => {
                this.$validator.reset();
            });
        },
        addNew() {
            this.resetForm();
            this.$bvModal.show('bv-modal-employment-documents');
        },
        onSubmit(e) {
            if (!this.checkNet()) return false;
            this.warningmsg = null;
            this.successmsg = null;


            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }
                this.hr_showoverlay = true;

                e.preventDefault();
                let currentObj = this;
                const config = {
                    headers: { 'content-type': 'multipart/form-data' }
                }

                let formData = new FormData();

                if (this.upload_file)
                    formData.append('upload_file', this.upload_file);

                for (let [key, value] of Object.entries(this.fdata)) {
                    var nm = `${key}`;
                    var fval = `${value}`;
                    formData.append(nm, fval);
                    //console.log(`${key}: ${value}`);
                }

                axios.post(this.$api_url + '/front/employment-document/details', formData, config)
                    .then(function (response) {
                        //console.log(response.data);
                        this.getDocumentList();

                        this.$bvToast.toast('Saved!', {
                            title: `Success`,
                            variant: 'success',
                            solid: true
                        });

                        this.hr_showoverlay = false;
                        this.resetForm();

                        this.$bvModal.hide('bv-modal-employment-documents');

                    }.bind(this))
                    .catch(function (error) {
                        this.hr_showoverlay = false;

                        currentObj.serverError(error);
                        currentObj.errormsg = error.response.data.errors;
                    });
            });
        },

    },
    created: function () {
        this.getDocumentList();
        Fire.$on('reloaddocuments', () => { this.getDocumentList() })
    },
    computed:
    {
        filteredData() {
            let filtered_list = this.documents;
            if (this.search) {
                filtered_list = filtered_list.filter((row) => { return Object.keys(row).some((key) => { return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1; }) });

                if (filtered_list.length == 0)
                    this.blankmsg = "No doucments found";
            }

            let sortKey = this.sortKey;
            let order = this.sortOrders[sortKey] || 1;
            if (sortKey) {
                filtered_list = filtered_list.slice().sort((a, b) => {
                    let index = this.getIndex(this.columns, 'name', sortKey);
                    a = String(a[sortKey]).toLowerCase();
                    b = String(b[sortKey]).toLowerCase();
                    if (this.columns[index].type && this.columns[index].type === 'date') {
                        return (a === b ? 0 : new Date(a).getTime() > new Date(b).getTime() ? 1 : -1) * order;
                    }
                    else if (this.columns[index].type && this.columns[index].type === 'number') {
                        return (+a === +b ? 0 : +a > +b ? 1 : -1) * order;
                    }
                    else {
                        return (a === b ? 0 : a > b ? 1 : -1) * order;
                    }
                }
                );
            }

            return filtered_list;
        },
        paginatedData() {
            return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
        }
    }
}
</script>
